import "core-js/actual";
import { ConnectedRouter } from "connected-react-router";
import PropTypes from "prop-types";
import { Provider } from "react-redux";
import configureStore from "common/helpers/configureStore";
import history from "common/helpers/history";
import { PostHogProvider, ErrorBoundary } from "common-components";
import { LoginNavLayout } from "../layouts/LoginNavLayout";
import rootReducer from "../reducers";
import { App } from "./App";
import "common/css/theme.scss";

const handleUpdate = () => window.scrollTo(0, 0);

const LoginApp = (props, railsContext) => {
  const store = configureStore(props, railsContext, history, rootReducer);
  const { user } = props;

  return (
    <ErrorBoundary>
      <Provider store={store}>
        <PostHogProvider user={user}>
          <ConnectedRouter onUpdate={handleUpdate} history={history}>
            <LoginNavLayout {...props}>
              <App />
            </LoginNavLayout>
          </ConnectedRouter>
        </PostHogProvider>
      </Provider>
    </ErrorBoundary>
  );
};

LoginApp.propTypes = {
  user: PropTypes.shape({
    token: PropTypes.string,
  }).isRequired,
};

export { LoginApp };
